export default "__VITE_ASSET__81esd6H2__"